import { z } from "zod"

export const customFieldAnswerSchema = z.object({
    id: z.string(),
    value: z.union([z.string(), z.boolean()]),
})

export type CustomFieldAnswer = z.infer<typeof customFieldAnswerSchema>

export const EMPTY_CUSTOM_FIELD_ANSWER = "-"
export const UNANSWERED_CUSTOM_FIELD_LABEL = "Not answered"

export const isCustomFieldAnswered = (value: CustomFieldAnswer["value"] | undefined): boolean =>
    value !== undefined && value !== ""

export const formatCustomFieldAnswer = (value: CustomFieldAnswer["value"] | undefined): string => {
    if (typeof value === "boolean") return value ? "Yes" : "No"
    if (!isCustomFieldAnswered(value)) return EMPTY_CUSTOM_FIELD_ANSWER
    return value as string
}

export const parseCustomFieldAnswers = (raw: unknown): CustomFieldAnswer[] => {
    const result = z.array(customFieldAnswerSchema).safeParse(raw)
    return result.success ? result.data : []
}

export const missionCustomFieldsRecordSchema = z.object({
    mission_id: z.uuid(),
    org_id: z.string(),
    answers: z.array(customFieldAnswerSchema),
    updated_at: z.string(),
})

export const missionCustomFieldsSchema = missionCustomFieldsRecordSchema.transform((r) => ({
    missionId: r.mission_id,
    orgId: r.org_id,
    answers: r.answers,
    updatedAt: r.updated_at,
}))

export const creatableMissionCustomFieldsSchema = missionCustomFieldsRecordSchema.pick({
    mission_id: true,
    answers: true,
})

export const updatableMissionCustomFieldsSchema = missionCustomFieldsRecordSchema.pick({
    answers: true,
})

export type MissionCustomFieldsRecord = z.infer<typeof missionCustomFieldsRecordSchema>
export type MissionCustomFields = z.infer<typeof missionCustomFieldsSchema>
export type CreatableMissionCustomFields = z.infer<typeof creatableMissionCustomFieldsSchema>
export type UpdatableMissionCustomFields = z.infer<typeof updatableMissionCustomFieldsSchema>
